import React                        from 'react';
import Typography                   from '@material-ui/core/Typography';
import { IViewTab }                 from '../ui/ViewTabs';
import employeeTimeOffTypeViewModel from './EmployeeTimeOffTypeViewModel';
import timeOffBalancesDialogModel   from '../schedule/TimeOffBalancesDialogModel';

const styles = {
  fontSize: '12px',
};

const employeeTimeOffTypeViewTabs: IViewTab[] = [
  {
    title:    'Transaction Details',
    disabled: () => employeeTimeOffTypeViewModel.isView('transactionDetails'),
    onClick:  employeeTimeOffTypeViewModel.handleViewButtonClick('transactionDetails'),
    content:  <Typography style={styles}>Transaction Details</Typography>
  },
  {
    title:    'Request History',
    disabled: () => employeeTimeOffTypeViewModel.isView('requestHistory'),
    visible:  () => timeOffBalancesDialogModel.canViewTimeOffRequests,
    onClick:  employeeTimeOffTypeViewModel.handleViewButtonClick('requestHistory'),
    content:  <Typography style={styles}>Request History</Typography>
  }
];

export default employeeTimeOffTypeViewTabs;
